import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './influencer-signup-info.scss';

applyTranslations(require('./influencer-signup-info.i18n.json'));

const conditions = [
  'followers',
  'location',
  'audience_location',
  'audience_credibility',
  'quality'
];

const InfluencerSignUpInfo = () => (
  <section className="influencer-signup-info">
    <div className="influencer-signup-info__title">
      {__t('influencer_signup_info.title')}
    </div>
    <div className="influencer-signup-info__desc">
      {__t('influencer_signup_info.desc')}
    </div>
    <div className="influencer-signup-info__items">
      {
        conditions.map(condition => (
          <li className="influencer-signup-info__item" key={condition}>
            {__t(`influencer_signup_info.${condition}`)}
          </li>
        ))
      }
    </div>
    <div className="influencer-signup-info__help">
      {__t('influencer_signup_info.email_help_part_1')}&nbsp;
      <a
        href="mailto:hello@collabary.com"
        className="influencer-signup-info__link"
      >
        hello@collabary.com
      </a>
      .&nbsp;{__t('influencer_signup_info.email_help_part_2')}
    </div>
  </section>
);

export default InfluencerSignUpInfo;
